export class Exception extends Error {
   public name: string = "Exception";
}
